module.exports = __webpack_public_path__ + "e4dd03f85572b833efccfbbb6bd223b0.png";